import React from "react";

const {
  REACT_APP_CLIENT_DETAILS: clientDetails,
  REACT_APP_CLIENT_TRADE_NAME: clientTradeName,
  REACT_APP_CLIENT_LOCATION: clientLocation,
} = process.env;

const ClientInfo = () => {
  return (
    <div className="col-span-1 p-10 bg-custom-yellow-500 rounded-xl">
      <div>
        <p className="font-medium font-lg uppercase">Client Info:</p>
        <div className="mt-5 flex justify-between">
          <div>
            <p className="font-semibold font-lg capitalize">Client Detial:</p>
            <p className="text-sm font-normal mt-2 capitalize">
              {clientDetails}
            </p>
          </div>
          <div>
            <p className="font-semibold font-lg capitalize">Trade Name:</p>
            <p className="text-sm font-normal mt-2 capitalize">
              {clientTradeName}
            </p>
          </div>
        </div>
        <div className="mt-5">
          <p className="font-semibold font-lg capitalize">Location:</p>
          <p className="text-sm font-normal mt-2 capitalize">
            {clientLocation}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ClientInfo;
